import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { customFieldsDirectoryResource } from '@jira/router-resources__admin-pages-custom-fields-directory/src/customFieldsDirectoryResource.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalSettingsCustomFieldsRoute } from '@jira/router-routes__global-settings-custom-fields-routes/src/globalSettingsCustomFieldsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import CustomFields, {
	LazyCustomFieldsDirectoryAdmin,
} from './ui/admin-pages/custom-fields-directory/index.tsx';

export const globalSettingsCustomFieldsRouteEntry: Route = createEntry(
	globalSettingsCustomFieldsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.custom-fields-directory',
		// eslint-disable-next-line no-restricted-syntax
		component: CustomFields,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			customFieldsDirectoryResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyCustomFieldsDirectoryAdmin],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
